<template>
  <!-- <div class="w3-container bg-gr2wh" style="padding:128px 16px" id="about"> -->
  <div class="w3-container bg-wh2gr" style="padding:64px 16px" id="about">
    <h3 class="w3-center" style="padding-bottom: 48px;">{{ $t('about.title') }}</h3>

    <div class="global-container">

      <!-- Основное описание -->
      <div v-for="(description, index) in descriptions" :key="'desc-' + index" class="about-card">
        <p v-html="description"></p>
      </div>

      <!-- 
      <div v-for="(description, index) in descriptions" :key="'desc-' + index" class="content-box">
            <p ><strong>rewrw</strong></p>
            <p v-html="description"></p>
        </div> -->

      <!-- <div class="w3-container" style="padding:0px 10%">
        <h3 class="w3-center">{{ $t('about.techstack.title') }}</h3>

        <div class="w3-ul" style="border: none;">

          <div v-for="(category, index) in techStack" :key="index">

            <h6 class="">{{ category.title }}</h6>
            <div class="w3-tags-container">
              <span v-for="(tech, techIndex) in category.technologies" :key="techIndex"
                class="w3-tag w3-blue w3-margin-bottom w3-margin-right">
                {{ tech }}
              </span>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>

</template>

<script>
export default {
  name: 'AboutSection',
  computed: {
    descriptions() {
      // $tm возвращает массив описаний как есть
      return this.$tm('about.studio.descriptions') || [];
    },
    projects() {
      // $tm возвращает объект projects, из которого берем list
      const projectsData = this.$tm('about.projects');
      return projectsData?.list || [];
    },
    techStack() {
      const techstackData = this.$tm('about.techstack')

      if (!techstackData || !techstackData.list) {
        return []
      }

      // Преобразуем данные для удобного использования в шаблоне
      return techstackData.list.map(category => ({
        title: category.title,
        technologies: Array.isArray(category.description)
          ? category.description
          : []
      }))
    },
  }
}
</script>

<style scoped>
.global-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: space-evenly;
  align-items: center;
}

.global-container div {
  margin: 5px;
  padding: 20px;
  font-size: 20px;
  /* width: 32%;   */
  width: 400px
}

.about-container {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.about-column {
  /* flex: 25%;
  max-width: 25%; */
  padding: 0 4px;
}

/* Responsive layout - makes a two column-layout instead of four columns */
/* Responsive layout - makes the two columns stack on top of each other instead of next to each other */
/* @media screen and (max-width: 800px) {
  .about-column {
    flex: 50%;
    max-width: 50%;
  }
}
@media screen and (max-width: 600px) {
  .about-column {
    flex: 100%;
    max-width: 100%;
  }
} */

.about-card {
  /* opacity: 1; */
  background: #ffffff;
  padding: 2.5rem 2rem;
  border-radius: 3px;
  font-size: large;
  /* text-align: center; */
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  height: 100%;
  /* display: flex;
  flex-direction: column;
  justify-content: flex-start; */
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;


  display: flex;
  justify-content: space-between;


  /* flex: 25%;
  max-width: 25%;
  padding: 0 4px; */
}

.about-card strong {
  /* color: #2c3e50; */
  font-weight: 500;
  background: linear-gradient(135deg, #364eaa 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.about-card::before {
  content: '';
  position: absolute;
  top: 0;
  /* bottom: 0; */
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #ca4672 0%, #ca4646 100%);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

/* .service-card:focus-within {
  outline: 2px solid #667eea;
  outline-offset: 2px;
} */

.about-card:hover {
  /* transform: translateY(-8px); */
  border-color: #ca4672;
  /* background-color: #f5eff1; */
  box-shadow: 0 8px 30px rgba(102, 126, 234, 0.15);
}

.about-card:hover::before {
  transform: scaleX(1);
}

.content-box:hover strong::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #3498db;
  animation: underline 0.5s ease-out 0.5s forwards;
  transform: scaleX(0);
  transform-origin: left;
}

@keyframes underline {
  to {
    transform: scaleX(1);
  }
}


.w3-card-4 {
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2), 0 4px 20px 0 rgba(0, 0, 0, 0.19);
}

.w3-ul li {
  transition: background-color 0.3s;
}

.w3-ul li:hover {
  background-color: #f1f1f1;
}
</style>